<template>
  <div id="paginaCalendarioMinistero">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Calendario Ministero</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropStagioni' ref='dropStagioni' :query='stagioniQuery' :dataSource='stagioniData'
                  :index='stagioniIndex' :fields='stagioniFields' :change='onStagioneChange'
                  placeholder='Seleziona una Stagione'></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1"></b-col>
              <b-col xl="12" md="12" class="pt-1">

                <!-- Timer Alert -->
                <b-col xl="6" md="12">
                  <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                    @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                    <p>Occorre selezionare una riga della tabella</p>
                    <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown"
                      height="4px" />
                  </b-alert>
                </b-col>

                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="calendarioMinisteroFullData" :allowSorting="true"
                    :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                    :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                    :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="100"></e-column>
                      <e-column field="disciplina" headerText="Disciplina" width="200"></e-column>
                      <e-column field="tipoAttivita" headerText="Tipo Attività" width="200"></e-column>
                      <e-column field="titoloRepertorio" headerText="Titolo/Repertorio" width="200"></e-column>
                      <e-column field="autore" headerText="Autore" width="200"></e-column>
                      <e-column field="vivente" headerText="Vivente" width="200"></e-column>
                      <e-column field="nazAutore" headerText="Nazionalità Autore" width="200"></e-column>
                      </e-column>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

    <!-- dialogA1: dialogDettaglioScrittura ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA1" ref="dialogA1" :header="dialogA1.header" :buttons="dialogA1.buttons"
      :visible="dialogA1.visible" :showCloseIcon="dialogA1.showCloseIcon" :close="dialogA1Close" :open="dialogA1Open"
      :zIndex="dialogA1.zIndex" :animationSettings="dialogA1.animationSettings">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Calendario Ministero" @click="tabClicked('dialogA1Tab01')">

          <b-row class="match-height">

            <!-- Card con Elementi Input: Dettaglio Calendario 1 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Calendario 1</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                    </template>
                    <b-dropdown-item href="#">
                      ...
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo dropdown senza azioni: calendarioMinisteroActiveData.disciplina  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="disciplina" class="h5">Disciplina</label>
                      <ejs-dropdownlist id="disciplina" v-model="calendarioMinisteroActiveData.disciplina"
                        :dataSource="calendarioMinisteroDisciplinaList" :fields="calendarioMinisteroDisciplinaFields"
                        placeholder="Disciplina" />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: calendarioMinisteroActiveData.tipoAttivita  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipoAttivita" class="h5">Tipo Attività</label>
                      <ejs-dropdownlist id="tipoAttivita" v-model="calendarioMinisteroActiveData.tipoAttivita"
                        :dataSource="calendarioMinisteroTipoAttivitaList"
                        :fields="calendarioMinisteroTipoAttivitaFields" placeholder="tipoAttivita" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.titoloRepertorio  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="titoloRepertorio" class="h5">Titolo/Repertorio</label>
                      <ejs-textbox id="titoloRepertorio" v-model="calendarioMinisteroActiveData.titoloRepertorio"
                        floatLabelType="Never" cssClass="" placeholder="Titolo/Repertorio" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.autore  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="autore" class="h5">Autore</label>
                      <ejs-textbox id="autore" v-model="calendarioMinisteroActiveData.autore" floatLabelType="Never"
                        cssClass="" placeholder="Autore" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo checkbox: calendarioMinisteroActiveData.vivente -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="vivente" class="h5 mr-1">Vivente</label>
                        <ejs-checkbox id="vivente" v-model="calendarioMinisteroActiveData.vivente"
                          :checked="calendarioMinisteroActiveData.vivente" name="vivente" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.nazAutore  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="nazAutore" class="h5">Nazionalità Autore</label>
                      <ejs-textbox id="nazAutore" v-model="calendarioMinisteroActiveData.nazAutore"
                        floatLabelType="Never" cssClass="" placeholder="Nazionalità Autore" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.regCorDir  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="regCorDir" class="h5">Regista/Coreografo/Direttore d'orchestra</label>
                      <ejs-textbox id="regCorDir" v-model="calendarioMinisteroActiveData.regCorDir"
                        floatLabelType="Never" cssClass="" placeholder="Regista/Coreografo/Direttore d'orchestra"
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo multilinea: calendarioMinisteroActiveData.interpreti  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="interpreti" class="h5">Intepreti principali/Solisti</label>
                      <ejs-textbox id="interpreti" v-model="calendarioMinisteroActiveData.interpreti"
                        floatLabelType="Never" cssClass="" placeholder="Intepreti principali/Solisti"
                        showClearButton="true" type="text" autocomplete="false" :multiline="true" :rows="6" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numeroTecnici -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numeroTecnici" class="h5">Numero Tecnici</label>
                      <ejs-numerictextbox id="numeroTecnici" v-model="calendarioMinisteroActiveData.numeroTecnici"
                        floatLabelType="Never" cssClass="" format="###" placeholder="Numero Tecnici"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numeroArtisti -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numeroArtisti" class="h5">Numero Artisti</label>
                      <ejs-numerictextbox id="numeroArtisti" v-model="calendarioMinisteroActiveData.numeroArtisti"
                        floatLabelType="Never" cssClass="" format="###" placeholder="Numero Artisti"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numeroProfOrchestraUE -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numeroProfOrchestraUE" class="h5">Numero Professori d'Orchestra Italiani o UE</label>
                      <ejs-numerictextbox id="numeroProfOrchestraUE"
                        v-model="calendarioMinisteroActiveData.numeroProfOrchestraUE" floatLabelType="Never" cssClass=""
                        format="###" placeholder="Numero Professori d'Orchestra Italiani o UE" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numeroProfOrchestraExtraUE -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numeroProfOrchestraExtraUE" class="h5">Numero Professori d'Orchestra Extra UE</label>
                      <ejs-numerictextbox id="numeroProfOrchestraExtraUE"
                        v-model="calendarioMinisteroActiveData.numeroProfOrchestraExtraUE" floatLabelType="Never"
                        cssClass="" format="###" placeholder="Numero Professori d'Orchestra Extra UE"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo checkbox: calendarioMinisteroActiveData.operaDaCamera -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="operaDaCamera" class="h5 mr-1">Opera da Camera</label>
                        <ejs-checkbox id="operaDaCamera" v-model="calendarioMinisteroActiveData.operaDaCamera"
                          :checked="calendarioMinisteroActiveData.operaDaCamera" name="operaDaCamera" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numeroProveGenerali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numeroProveGenerali" class="h5">Numero Prove Generali</label>
                      <ejs-numerictextbox id="numeroProveGenerali"
                        v-model="calendarioMinisteroActiveData.numeroProveGenerali" floatLabelType="Never" cssClass=""
                        format="###" placeholder="Numero Prove Generali" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numeroProveAnteGenerali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numeroProveAnteGenerali" class="h5">Numero Prove Ante Generali</label>
                      <ejs-numerictextbox id="numeroProveAnteGenerali"
                        v-model="calendarioMinisteroActiveData.numeroProveAnteGenerali" floatLabelType="Never"
                        cssClass="" format="###" placeholder="Numero Prove Ante Generali" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numeroProveApertePubblico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numeroProveApertePubblico" class="h5">Numero Prove Aperte al Pubblico</label>
                      <ejs-numerictextbox id="numeroProveApertePubblico"
                        v-model="calendarioMinisteroActiveData.numeroProveApertePubblico" floatLabelType="Never"
                        cssClass="" format="###" placeholder="Numero Prove Aperte al Pubblico" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo data: calendarioMinisteroActiveData.periodoDal -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="periodoDal" class="h5">Periodo dal</label>
                      <ejs-datepicker id="periodoDal" v-model="calendarioMinisteroActiveData.periodoDal"
                        :format="settings.formatoData" placeholder="Periodo dal" />
                    </b-col>

                    <!-- Input di tipo data: calendarioMinisteroActiveData.periodoAl -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="periodoAl" class="h5">Periodo al</label>
                      <ejs-datepicker id="periodoAl" v-model="calendarioMinisteroActiveData.periodoAl"
                        :format="settings.formatoData" placeholder="Periodo al" />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: calendarioMinisteroActiveData.nuovaProduzione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="nuovaProduzione" class="h5">Nuova Produzione/Ripresa</label>
                      <ejs-dropdownlist id="nuovaProduzione" v-model="calendarioMinisteroActiveData.nuovaProduzione"
                        :dataSource="calendarioMinisteroNuovaProduzioneList"
                        :fields="calendarioMinisteroNuovaProduzioneFields" placeholder="Nuova Produzione/Ripresa" />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: calendarioMinisteroActiveData.prodotto  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="prodotto" class="h5">Prodotto/Ospitato</label>
                      <ejs-dropdownlist id="prodotto" v-model="calendarioMinisteroActiveData.prodotto"
                        :dataSource="calendarioMinisteroProdottoList" :fields="calendarioMinisteroProdottoFields"
                        placeholder="Prodotto/Ospitato" />
                    </b-col>


























                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Calendario 2 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Calendario 2</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                    </template>
                    <b-dropdown-item href="#">
                      ...
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>



                    <!-- Input di tipo checkbox: calendarioMinisteroActiveData.coproduzione -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="coproduzione" class="h5 mr-1">Coproduzione</label>
                        <ejs-checkbox id="coproduzione" v-model="calendarioMinisteroActiveData.coproduzione"
                          :checked="calendarioMinisteroActiveData.coproduzione" name="Coproduzione" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo multilinea: calendarioMinisteroActiveData.coprodNomePIva  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="coprodNomePIva" class="h5">Se si: Nome Coproduttore e P.IVA</label>
                      <ejs-textbox id="coprodNomePIva" v-model="calendarioMinisteroActiveData.coprodNomePIva"
                        floatLabelType="Never" cssClass="" placeholder="Nome Coproduttore e P.IVA"
                        showClearButton="true" type="text" autocomplete="false" :multiline="true" :rows="2" />
                    </b-col>


                    <!-- Input di tipo testo: calendarioMinisteroActiveData.sede  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="sede" class="h5">Sede/Spazio</label>
                      <ejs-textbox id="sede" v-model="calendarioMinisteroActiveData.sede" floatLabelType="Never"
                        cssClass="" placeholder="Sede/Spazio" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.capienza -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="capienza" class="h5">Capienza</label>
                      <ejs-numerictextbox id="capienza" v-model="calendarioMinisteroActiveData.capienza"
                        floatLabelType="Never" cssClass="" format="### posti" placeholder="Capienza"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.dimPalcoscenico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dimPalcoscenico" class="h5">Dimensioni Palcoscenico</label>
                      <ejs-numerictextbox id="dimPalcoscenico" v-model="calendarioMinisteroActiveData.dimPalcoscenico"
                        floatLabelType="Never" cssClass="" format="### m" placeholder="Dimensioni Palcoscenico"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.dimGolfoMistico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dimGolfoMistico" class="h5">Dimensioni Golfo Mistico</label>
                      <ejs-numerictextbox id="dimGolfoMistico" v-model="calendarioMinisteroActiveData.dimGolfoMistico"
                        floatLabelType="Never" cssClass="" format="### m" placeholder="Dimensioni Golfo Mistico"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.carattAcustiche  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="carattAcustiche" class="h5">Caratteristiche Acustiche</label>
                      <ejs-textbox id="carattAcustiche" v-model="calendarioMinisteroActiveData.carattAcustiche"
                        floatLabelType="Never" cssClass="" placeholder="Caratteristiche Acustiche"
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numRecite -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numRecite" class="h5">Numero Recite/Concerti/Manifestazioni</label>
                      <ejs-numerictextbox id="numRecite" v-model="calendarioMinisteroActiveData.numRecite"
                        floatLabelType="Never" cssClass="" format="###"
                        placeholder="Numero Recite/Concerti/Manifestazioni" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numReciteScuole -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numReciteScuole" class="h5">Di cui Giornate e Mattine per Scuole</label>
                      <ejs-numerictextbox id="numReciteScuole" v-model="calendarioMinisteroActiveData.numReciteScuole"
                        floatLabelType="Never" cssClass="" format="###"
                        placeholder="Di cui Giornate e Mattine per Scuole" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.giornLavTerzi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="giornLavTerzi" class="h5">Giornate Lavorative Terzi</label>
                      <ejs-numerictextbox id="giornLavTerzi" v-model="calendarioMinisteroActiveData.giornLavTerzi"
                        floatLabelType="Never" cssClass="" format="###" placeholder="Giornate Lavorative Terzi"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: calendarioMinisteroActiveData.ingressoGratuito  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="ingressoGratuito" class="h5">Ingresso Gratuito/A Pagamento</label>
                      <ejs-dropdownlist id="ingressoGratuito" v-model="calendarioMinisteroActiveData.ingressoGratuito"
                        :dataSource="calendarioMinisteroIngressoGratuitoList"
                        :fields="calendarioMinisteroIngressoGratuitoFields"
                        placeholder="Ingresso Gratuito/A Pagamento" />
                    </b-col>

                    <!-- Input di tipo checkbox: calendarioMinisteroActiveData.streaming -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="streaming" class="h5 mr-1">Trasmissione in Modalità Streaming </label>
                        <ejs-checkbox id="streaming" v-model="calendarioMinisteroActiveData.streaming"
                          :checked="calendarioMinisteroActiveData.streaming" name="streaming" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: calendarioMinisteroActiveData.eventoRiprogrammato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="eventoRiprogrammato" class="h5 mr-1">Evento Riprogrammato</label>
                        <ejs-checkbox id="eventoRiprogrammato"
                          v-model="calendarioMinisteroActiveData.eventoRiprogrammato"
                          :checked="calendarioMinisteroActiveData.eventoRiprogrammato" name="eventoRiprogrammato" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo multilinea: calendarioMinisteroActiveData.interpretiNaz  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="interpretiNaz" class="h5">Interpreti principali/Solisti/Nazionalità</label>
                      <ejs-textbox id="interpretiNaz" v-model="calendarioMinisteroActiveData.interpretiNaz"
                        floatLabelType="Never" cssClass="" placeholder="Interpreti principali/Solisti/Nazionalità"
                        showClearButton="true" type="text" autocomplete="false" :multiline="true" :rows="6" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.orchestraNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="orchestraNome" class="h5">Orchestra</label>
                      <ejs-textbox id="orchestraNome" v-model="calendarioMinisteroActiveData.orchestraNome"
                        floatLabelType="Never" cssClass="" placeholder="Orchestra" showClearButton="true" type="text"
                        autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.orchestraNaz  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="orchestraNaz" class="h5">Nazionalità Orchestra</label>
                      <ejs-textbox id="orchestraNaz" v-model="calendarioMinisteroActiveData.orchestraNaz"
                        floatLabelType="Never" cssClass="" placeholder="Nazionalità Orchestra" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.coroNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="coroNome" class="h5">Nome Coro</label>
                      <ejs-textbox id="coroNome" v-model="calendarioMinisteroActiveData.coroNome" floatLabelType="Never"
                        cssClass="" placeholder="Nome Coro" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numCoristi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numCoristi" class="h5">Numero Coristi</label>
                      <ejs-numerictextbox id="numCoristi" v-model="calendarioMinisteroActiveData.numCoristi"
                        floatLabelType="Never" cssClass="" format="###" placeholder="Numero Coristi"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.coroNaz  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="coroNaz" class="h5">Nazionalità Coro</label>
                      <ejs-textbox id="coroNaz" v-model="calendarioMinisteroActiveData.coroNaz" floatLabelType="Never"
                        cssClass="" placeholder="Nazionalità Orchestra" showClearButton="true" type="text"
                        autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo numero: calendarioMinisteroActiveData.numCorpoBallo -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numCorpoBallo" class="h5">Corpo di Ballo (se presente)</label>
                      <ejs-numerictextbox id="numCorpoBallo" v-model="calendarioMinisteroActiveData.numCorpoBallo"
                        floatLabelType="Never" cssClass="" format="###" placeholder="Corpo di Ballo"
                        showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo testo: calendarioMinisteroActiveData.coreografoNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="coreografoNome" class="h5">Nome Coreografo</label>
                      <ejs-textbox id="coreografoNome" v-model="calendarioMinisteroActiveData.coreografoNome"
                        floatLabelType="Never" cssClass="" placeholder="Nome Coreografo" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>



                    <!-- Input di tipo dropdown senza azioni: calendarioMinisteroActiveData.codiceINPS  -->
                    <!-- ESEMPIO ATTUALE AL 9/1/23 di dropdown con ricerca e template, ben funzionante -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codiceINPS" class="h5">Codice INPS</label>
                      <ejs-dropdownlist id="codiceINPS" v-model="calendarioMinisteroActiveData.codiceINPS"
                        :dataSource="calendarioMinisteroINPSList" :fields="calendarioMinisteroINPSFields"
                        :allowFiltering='calendarioMinisteroINPSAllowFiltering' :itemTemplate='itemTemplate'
                        :filtering='calendarioMinisteroINPSFiltering' placeholder="Codice INPS" />
                    </b-col>







                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>





          </b-row>
        </b-tab>



      </b-tabs>
    </ejs-dialog>




  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin, CarouselPlugin, FormRatingPlugin,
} from 'bootstrap-vue'
// import Vuexy
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data';
// import {
//   extend, addClass, createElement, isNullOrUndefined, detach, EventHandler,
// } from '@syncfusion/ej2-base'
import {
  DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin, CalendarPlugin
} from '@syncfusion/ej2-vue-calendars'
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, SliderPlugin, UploaderPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns'
import {
  RichTextEditorPlugin, Link, Image, Count, HtmlEditor, QuickToolbar, Toolbar as RTToolbar,
} from '@syncfusion/ej2-vue-richtexteditor' // rinominato Toolbar RTToolbar incomp con Word
import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet'
import {
  SchedulePlugin, Day, Week, WorkWeek, Month, Agenda,
} from '@syncfusion/ej2-vue-schedule'
import { DocumentEditorContainerPlugin, DocumentEditorContainerComponentm, Toolbar } from '@syncfusion/ej2-vue-documenteditor'
import {
  PdfViewerPlugin, Magnification, Navigation, LinkAnnotation, BookmarkView, ThumbnailView, Print, TextSelection, TextSearch, Annotation, FormFields, FormDesigner, Toolbar as PDFToolbar,
} from '@syncfusion/ej2-vue-pdfviewer' // rinominato Toolbar PDFToolbar incomp con Word
import { KanbanPlugin } from '@syncfusion/ej2-vue-kanban'
import {
  GanttPlugin, Edit, Filter, Sort,
} from '@syncfusion/ej2-vue-gantt'
import { DiagramPlugin } from '@syncfusion/ej2-vue-diagrams'
import {
  MapsPlugin, Bubble, Zoom, MapsTooltip, Marker, NavigationLine,
} from '@syncfusion/ej2-vue-maps'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(ImagePlugin)
Vue.use(EmbedPlugin)
Vue.use(TablePlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
Vue.use(CarouselPlugin)
Vue.use(FormRatingPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(MaskedTextBoxPlugin)
Vue.use(SliderPlugin)
Vue.use(UploaderPlugin)
Vue.use(DateRangePickerPlugin)
Vue.use(DatePickerPlugin)
Vue.use(DateTimePickerPlugin)
Vue.use(TimePickerPlugin)
Vue.use(DropDownListPlugin)
Vue.use(MultiSelectPlugin)
Vue.use(ButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(SwitchPlugin)
Vue.use(RichTextEditorPlugin)
Vue.use(SpreadsheetPlugin)
Vue.use(SchedulePlugin)
Vue.use(DocumentEditorContainerPlugin)
Vue.use(PdfViewerPlugin)
Vue.use(KanbanPlugin)
Vue.use(GanttPlugin)
Vue.use(DiagramPlugin)
Vue.use(MapsPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ListBoxPlugin)
enableRipple(true)
Vue.use(CalendarPlugin);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT
//const apicalendarioMinisteroUrl = '/demo/api/artista'
const apicalendarioMinisteroUrl = '/demo/api/soggetto'


var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='name'>{{data.label}}</span><span class ='city'>{{data.group}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

export default Vue.extend({
  components: {
  },
  data() {
    return {
      // per dropdownlist con template
      itemTemplate: function () {
        return { template: itemVue };
      },
      // per dropdownlist combinate
      stagioniData: [
        { StagioneName: 'Stagione 2022', StagioneId: '1' },
        { StagioneName: 'Stagione 2023', StagioneId: '2' }
      ],
      stagioniFields: { value: 'StagioneId', text: 'StagioneName' },
      stagioniIndex: -1,
      stagioniQuery: null,
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      // calendario ministero
      calendarioMinisteroFullData: [], // elenco completo dati produzioni
      calendarioMinisteroActiveId: 0, // Id soggetto attivo (0 se nuovo)
      calendarioMinisteroActiveData: {}, // dati completi dell soggetto attivo
      calendarioMinisteroSavedData: {}, // dati completi dell soggetto attivo
      calendarioMinisteroDefaultData: {}, // dati completi di default per nuovi produzioni
      calendarioMinisteroNazionalitaList: [
        { label: 'Italiana o UE', id: 'ue' },
        { label: 'Extra UE', id: 'extra-ue' }], // elenco delle nazionalità 
      calendarioMinisteroNazionalitaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista della nazionalità
      calendarioMinisteroINPSList: [
        { label: '011 artisti lirici', id: '011', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '012 cantanti di musica leggera', id: '012', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '013 coristi, vocalisti', id: '013', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '014 maestri del coro, assistenti e aiuti del coro, suggeritori del coro', id: '014', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '021 attori di prosa, mimi, allievi attori', id: '021', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '022 attori cinematografici o di audiovisivi', id: '022', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '023 attori di doppiaggio', id: '023', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '024 attori di operetta', id: '024', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '025 attori di rivista, attori di varietà ed attrazioni', id: '025', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '026 artisti del circo', id: '026', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '027 attori di fotoromanzi', id: '027', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '028 suggeritori teatrali, cinematografici o di audiovisivi', id: '028', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '029 generici, figuranti', id: '029', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '821 imitatori, ipnotizzatori, illusionisti e prestigiatori', id: '821', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '822 marionettisti, burattinai', id: '822', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '823 acrobati, stuntman, contorsionisti', id: '823', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: "824 maestri d'armi", id: '824', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '031 presentatori', id: '031', cat: 'Gruppo conduttori e animatori', group: 'Raggruppamento A' },
        { label: '032 disc-jockey', id: '032', cat: 'Gruppo conduttori e animatori', group: 'Raggruppamento A' },
        { label: '033 animatori in strutture turistiche e di spettacolo', id: '033', cat: 'Gruppo conduttori e animatori', group: 'Raggruppamento A' },
        { label: '041 registi teatrali, cinematografici o di audiovisivi', id: '041', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '042 aiuti registi teatrali, cinematografici o di audiovisivi', id: '042', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '043 sceneggiatori teatrali, cinematografici o di audiovisivi', id: '043', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '044 dialoghisti, adattatori cinetelevisivi o di audiovisivi', id: '044', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '045 direttori della fotografia, light designer', id: '045', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '046 soggettisti', id: '046', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '047 video-assist', id: '047', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '051 direttori di produzione', id: '051', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '052 ispettori di produzione', id: '052', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '053 segretari di produzione', id: '053', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '054 segretari di edizione', id: '054', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '055 cassieri di produzione', id: '055', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '056 organizzatori generali, location manager', id: '056', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '057 responsabili di edizione della produzione cinematografica e televisiva', id: '057', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '058 casting director', id: '058', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '059 documentalisti audiovisivi', id: '059', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '061 direttori di scena', id: '061', cat: 'Gruppo direttori di scena e di doppiaggio', group: 'Raggruppamento A' },
        { label: '062 direttori di doppiaggio', id: '062', cat: 'Gruppo direttori di scena e di doppiaggio', group: 'Raggruppamento A' },
        { label: '063 assistenti di scena e di doppiaggio', id: '063', cat: 'Gruppo direttori di scena e di doppiaggio', group: 'Raggruppamento A' },
        { label: "071 direttori d'orchestra", id: '071', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: "072 sostituti direttori d'orchestra", id: '072', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '073 maestri collaboratori', id: '073', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '074 maestri di banda', id: '074', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '075 compositori', id: '075', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '081 concertisti e solisti', id: '081', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: "082 professori d'orchestra", id: '082', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '083 orchestrali (anche di musica leggera)', id: '083', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '084 bandisti', id: '084', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '085 consulenti assistenti musicali', id: '085', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '091 coreografi e assistenti coreografi', id: '091', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '092 ballerini e tersicorei', id: '092', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '093 indossatori', id: '093', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '094 figuranti lirici', id: '094', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '095 figuranti di sala', id: '095', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '096 fotomodelli', id: '096', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '097 cubisti', id: '097', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '098 spogliarellisti', id: '098', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '101 amministratori di formazioni artistiche', id: '101', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '102 amministratori di produzione cinematografica e audiovisiva', id: '102', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '103 organizzatori teatrali', id: '103', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '104 amministratori e segretari di compagnie teatrali', id: '104', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '111 tecnici del montaggio, del suono e sound designer della produzione cinematografica', id: '111', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '112 tecnici del montaggio, del suono e sound designer del teatro', id: '112', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '113 tecnici del montaggio, del suono e sound designer di audiovisivi', id: '113', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '114 tecnici del montaggio e del suono di altri settori dello spettacolo', id: '114', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '115 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici della produzione cinematografica', id: '115', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '116 tecnici di luci, scena, effetti speciali ed altri tecnici del teatro', id: '116', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '117 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici di audiovisivi', id: '117', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '118 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici di fotoromanzi', id: '118', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '119 tecnici addetti alle manifestazioni di moda', id: '119', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '121 operatori di ripresa cinematografica o audiovisiva', id: '121', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '122 aiuto operatori di ripresa cinematografica o audiovisiva', id: '122', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '123 maestranze cinematografiche', id: '123', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '124 maestranze teatrali', id: '124', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '125 maestranze di imprese audiovisive', id: '125', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '126 fotografi di scena', id: '126', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '131 architetti, arredatori', id: '131', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '132 costumisti, modisti, figurinisti e sarti teatrali, cinematografici o di audiovisivi', id: '132', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '133 scenografi', id: '133', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '134 bozzettista', id: '134', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '135 story board artist', id: '135', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: "136 creatori di fumetti, illustrazioni e disegni finalizzati all'animazione", id: '136', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '141 truccatori', id: '141', cat: 'Gruppo truccatori e parrucchieri', group: 'Raggruppamento A' },
        { label: '142 parrucchieri', id: '142', cat: 'Gruppo truccatori e parrucchieri', group: 'Raggruppamento A' },
        { label: '500 lavoratori autonomi esercenti attività musicali', id: '500', cat: 'Gruppo lavoratori autonomi esercenti attività musicali', group: 'Raggruppamento A' },
        { label: '154 artieri ippici', id: '154', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '155 operatori di cabine di sale cinematografiche', id: '155', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '156 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio', id: '156', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '157 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio dipendenti dagli enti ed imprese esercenti pubblici spettacoli', id: '157', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '158 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio dipendenti dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '158', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '201 impiegati amministrativi e tecnici dipendenti dalle imprese radiofoniche, televisive o di audiovisivi', id: '201', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '202 impiegati amministrativi e tecnici dipendenti dagli enti ed imprese esercenti pubblici spettacoli', id: '202', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '203 impiegati amministrativi e tecnici dipendenti dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '203', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '204 autisti dipendenti dagli enti ed imprese esercenti pubblici spettacoli, dalle imprese radiofoniche, televisive o di audiovisivi, dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '204', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '205 operai dipendenti dagli enti ed imprese esercenti pubblici spettacoli, dalle imprese radiofoniche, televisive o di audiovisivi, dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '205', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '211 impiegati dipendenti da ippodromi, scuderie di cavalli da corsa e cinodromi', id: '211', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '212 operai dipendenti da ippodromi, scuderie di cavalli da corsa e cinodromi', id: '212', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '213 impiegati dipendenti dalle imprese di spettacoli viaggianti', id: '213', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '214 operai dipendenti dalle imprese di spettacoli viaggianti', id: '214', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '217 impiegati dipendenti dalle case da gioco', id: '217', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '218 operai dipendenti dalle case da gioco', id: '218', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: "219 prestatori d'opera addetti ai totalizzatori o alla ricezione delle scommesse, presso gli ippodromi e cinodromi, nonché presso le sale da corsa e le agenzie ippiche", id: '219', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '235 impiegati dipendenti dalle sale scommesse', id: '235', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '236 operai dipendenti dalle sale scommesse', id: '236', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '237 impiegati dipendenti dalle sale giochi', id: '237', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '238 operai dipendenti dalle sale giochi', id: '238', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '215 impiegati dipendenti da impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '215', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '216 operai dipendenti da impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '216', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '771 istruttori presso impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '771', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '772 addetti agli impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '772', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '773 impiegati dipendenti da società sportive', id: '773', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '774 operai dipendenti da società sportive', id: '774', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '775 direttori tecnici presso società sportive', id: '775', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '776 massaggiatori presso società sportive', id: '776', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '777 istruttori presso società sportive', id: '777', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '231 impiegati dipendenti dalle imprese esercenti il noleggio e la distribuzione dei film', id: '231', cat: "Gruppo dipendenti da imprese di noleggio films", group: 'Raggruppamento B' },
        { label: '232 operai dipendenti dalle imprese esercenti il noleggio e la distribuzione dei film', id: '232', cat: "Gruppo dipendenti da imprese di noleggio films", group: 'Raggruppamento B' },
      ], // elenco codici INPS
      calendarioMinisteroINPSFields: { groupBy: 'cat', text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista dei codici INPS
      calendarioMinisteroINPSAllowFiltering: true,
      calendarioMinisteroDisciplinaList: [
        { label: 'Musica', id: 'musica' },
        { label: 'Danza', id: 'danza' }], // elenco disciplina
      calendarioMinisteroDisciplinaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista disciplina
      calendarioMinisteroTipoAttivitaList: [
        { label: 'Opera Lirica', id: 'operaLirica' },
        { label: 'Opera da Camera', id: 'operaDaCamera' },
        { label: 'Musical con Musica dal Vivo', id: 'musical' },
        { label: 'Operetta con Musica dal Vivo', id: 'operetta' },
        { label: 'Danza', id: 'danza' },
        { label: 'Concerti', id: 'concerti' }], // elenco tipologia attivita
      calendarioMinisteroTipoAttivitaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista tipologia attivita
      calendarioMinisteroNuovaProduzioneList: [
        { label: 'Nuova Produzione', id: 'nuovaProduzione' },
        { label: 'Ripresa', id: 'ripresa' }], // elenco NuovaProduzione
      calendarioMinisteroNuovaProduzioneFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista NuovaProduzione
      calendarioMinisteroProdottoList: [
        { label: 'Prodotto', id: 'prodotto' },
        { label: 'Ospitato', id: 'ospitato' }], // elenco prodotto
      calendarioMinisteroProdottoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista prodotto
      calendarioMinisteroIngressoGratuitoList: [
        { label: 'Gratuito', id: 'gratuito' },
        { label: 'A Pagamento', id: 'pagamento' }], // elenco IngressoGratuito
      calendarioMinisteroIngressoGratuitoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista IngressoGratuito


      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogA1Ok, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogA1Cancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Nuovo', tooltipText: 'Nuovo', prefixIcon: 'e-plus', id: 'new',
          },
          {
            text: 'Modifica', tooltipText: 'Modifica', prefixIcon: 'e-expand', id: 'edit',
          },
          {
            text: 'Cancella', tooltipText: 'Cancella', prefixIcon: 'e-cancel', id: 'delete',
          },
          'Search',
        ],
      }, //



    }
  },
  created() {
    // log
    console.log('Pagina Calendario Ministero Creata')
    // inizializzazione elenchi dal backend
    // chiamate API


    // calendarioMinisteroFullData
    // recupero elenco calendarioMinistero dal backend
    // if (localStorage.getItem('userData') !== null) {
    //   console.log('Recupero elenco produzioni dal backend')
    //   useJwt.get(apicalendarioMinisteroUrl).then(d => {
    //     console.log('produzioni')
    //     console.log(d.data)
    //     this.calendarioMinisteroFullData = d.data
    //   })
    // } else {
    //   console.log('Non trovo UserData, prova ancora')
    // }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente
    // calendarioMinisteroDefaultData
    this.calendarioMinisteroDefaultData = {

      id: 0,
      stagione: null,
      disciplina: null,
      tipoAttivita: null,
      titoloRepertorio: '',
      autore: '',
      vivente: false,
      nazAutore: '',
      regCorDir: '',
      interpreti: '',
      numeroTecnici: null,
      numeroArtisti: null,
      numeroProfOrchestraUE: null,
      numeroProfOrchestraExtraUE: null,
      operaDaCamera: false,
      numeroProveGenerali: null,
      numeroProveAnteGenerali: null,
      numeroProveApertePubblico: null,
      periodoDal: null,
      periodoAl: null,
      nuovaProduzione: null,
      prodotto: null,
      coproduzione: false,
      coprodNomePIva: '',
      sede: '',
      capienza: null,
      dimPalcoscenico: null,
      dimGolfoMistico: null,
      carattAcustiche: '',
      numRecite: null,
      numReciteScuole: null,
      giornLavTerzi: null,
      ingressoGratuito: false,
      streaming: false,
      eventoRiprogrammato: false,
      interpretiNaz: '',
      orchestraNome: '',
      orchestraNaz: '',
      coroNome: '',
      numCoristi: null,
      coroNaz: '',
      numCorpoBallo: null,
      coreografoNome: '',
      codiceINPS: null,
    }


  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn()
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit],
    // per listBox
    listbox: [CheckBoxSelection],
  },
  methods: {
    // per elenco inps
    calendarioMinisteroINPSFiltering: function (e) {
      var searchData = this.calendarioMinisteroINPSList;
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("label", "contains", e.text, true) : query; // puoi usare contains, startsWith, or endsWith
      //pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    // per dropdownlist combinate
    onStagioneChange: function (e) {
      // abilito gridA
      this.$refs.gridA.$el.classList.remove('disablegrid');
      document.getElementById("GridParent").classList.remove('wrapper');
      // Inserire la chiamata per popolare la gridA
      // aggiungo provvisoriamente il popolamento di calendarioMinisteroFullData (sostituire con chiamata API)
      this.calendarioMinisteroFullData = [
        {
          id: 1,
          stagione: '2023',
          disciplina: null,
          tipoAttivita: null,
          titoloRepertorio: '',
          autore: '',
          vivente: false,
          nazAutore: '',
          regCorDir: '',
          interpreti: '',
          numeroTecnici: null,
          numeroArtisti: null,
          numeroProfOrchestraUE: null,
          numeroProfOrchestraExtraUE: null,
          operaDaCamera: false,
          numeroProveGenerali: null,
          numeroProveAnteGenerali: null,
          numeroProveApertePubblico: null,
          periodoDal: null,
          periodoAl: null,
          nuovaProduzione: null,
          prodotto: null,
          coproduzione: false,
          coprodNomePIva: '',
          sede: '',
          capienza: null,
          dimPalcoscenico: null,
          dimGolfoMistico: null,
          carattAcustiche: '',
          numRecite: null,
          numReciteScuole: null,
          giornLavTerzi: null,
          ingressoGratuito: false,
          streaming: false,
          eventoRiprogrammato: false,
          interpretiNaz: '',
          orchestraNome: '',
          orchestraNaz: '',
          coroNome: '',
          numCoristi: null,
          coroNaz: '',
          numCorpoBallo: null,
          coreografoNome: '',
          codiceINPS: null,
        },

      ]
    },

    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true)
    },
    dialogA1Open() {
      console.log('Apertura dialogA1')
      // assegnare le informazioni da visualizzare nel dialog A
      console.log('Calendario Ministero Attivo')
      console.log(this.calendarioMinisteroActiveId)
      // // gestione doccalendarioMinisteroFullData
      // // recupero le informazioni pertinenti da doccalendarioMinisteroFullData
      // const list = this.doccalendarioMinisteroFullData // lista di origine
      // const ids = [this.calendarioMinisteroActiveId] // ID soggetto da cercare nell'elenco info produzioni
      // const newArr = list.filter(item => ids.includes(item.artista)) // item.artista è dove cercare
      // // aggiorno calendarioMinisteroActiveData.documenti
      // console.log('DOCUMENTI SOGGETTO CORRENTE')
      // this.calendarioMinisteroActiveData.documenti = newArr
      // console.log(this.calendarioMinisteroActiveData.documenti)

      this.calendarioMinisteroSavedData = { ...this.calendarioMinisteroActiveData }

      // this.imgcalendarioMinisteroActiveData = this.imgcalendarioMinisteroDefaultData
      // this.imgcalendarioMinisteroActiveId = 0
    },
    dialogA1Close() {
      console.log('Chiusura dialogA1')
      this.dialogA1.tabAdialogA1Index = 0
    },
    dialogA1Ok() {
      console.log('Cliccato bottone OK di dialogA1')
      // salvataggio informazioni in remoto
      if (this.calendarioMinisteroActiveId === 0) {
        // salvataggio in caso di new
        useJwt.post(apicalendarioMinisteroUrl, this.calendarioMinisteroActiveData).then(res => {
          console.log(res.status)
          console.log(res.data)
          // mi segno ID elemento appena creato
          this.calendarioMinisteroActiveId = res.data.id
          return this // restituisci contesto per permettere aggiornamento grid
        }).then(context => {
          useJwt.get(apicalendarioMinisteroUrl).then(res => {
            console.log("Aggiornamento gridA con l'aggiunta di un soggetto")
            context.calendarioMinisteroFullData = res.data
            context.calendarioMinisteroFullData = [...context.calendarioMinisteroFullData]
          })
        })
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apicalendarioMinisteroUrl}/${this.calendarioMinisteroActiveId}`
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        useJwt.patch(editUrl, this.calendarioMinisteroActiveData).then(res => {
          console.log(res.status)
          return this // restituisci contesto per permettere aggiornamento gridA
        }).then(context => {
          useJwt.get(apicalendarioMinisteroUrl).then(res => {
            console.log('Aggiornamento gridA con la modifica di un soggetto')
            context.calendarioMinisteroFullData = res.data
            context.calendarioMinisteroFullData = [...context.calendarioMinisteroFullData]
          })
        })
      }
      this.$refs.dialogA1.hide()
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogA1Cancel() {
      console.log('Cliccato bottone Cancel di dialogA1')
      this.$refs.dialogA1.hide()
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === 'new') {
        this.dialogA1.header = 'Nuovo elemento calendario ministero'
        this.calendarioMinisteroActiveData = this.calendarioMinisteroDefaultData
        console.log('Premuto pulsante creazione nuovo elemento calendario ministero da gridA')
        // console.log(this.calendarioMinisteroActiveData);
        // console.log(this.calendarioMinisteroDefaultData);
        this.calendarioMinisteroActiveId = 0
        this.$refs.dialogA1.show(true)
      }
      // pulsante EDIT 
      else if (args.item.id === 'edit') {
        this.dialogA1.header = 'Modifica Elemento Calendario Ministero'
        console.log('Premuto pulsante modifica soggetto da gridA')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          let found = false
          this.calendarioMinisteroActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:");
          console.log(this.calendarioMinisteroActiveId)
          for (const i in this.calendarioMinisteroFullData) {
            if (this.calendarioMinisteroFullData[i].id === this.calendarioMinisteroActiveId) {
              // console.log("id dell'elenco trovato:")
              // console.log('SOGGETTO CORRENTE')
              // console.log(this.calendarioMinisteroFullData[i])
              this.calendarioMinisteroActiveData = { ...this.calendarioMinisteroFullData[i] }
              found = true
              break
            }
          }
          console.log('Elemento Calendario Ministero Corrente')
          console.log(this.calendarioMinisteroActiveData)
          console.log(this.calendarioMinisteroActiveId)



          if (found) {
            // Calendario ministero
            console.log('Edit elemento calendario ministero')
            this.$refs.dialogA1.show(true)
          }
          else { console.log('Elemento non trovato') }
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
      // Pulsante DELETE 
      else if (args.item.id === 'delete') {
        try {
          console.log('Premuto pulsante elimina elemento calendario ministero da gridA')
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const deletedElementId = selectedRow[0].id

          const deleteUrl = `${apicalendarioMinisteroUrl}/${deletedElementId}`
          this.$refs.gridA.ej2Instances.deleteRecord()

          useJwt.delete(deleteUrl).then(res => {
            console.log('Eliminazione avvenuta con successo')
            // console.log(res.data)
          })
        } catch (err) {
          // da sistemare..............
          console.log(err)
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === 'save') {
          const editedData = e.data
          console.log(editedData)
          // The default edit operation is cancelled
          e.cancel = true
          const editUrl = `${apicalendarioMinisteroUrl}/${editedData.id}`
          useJwt.patch(editUrl, editedData).then(res => {
            console.log(res)
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit()
            } else {
              this.makeToast('primary', 'Attenzione', 'Salvataggio soggetto non riuscito')
            }
          })
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === 'save') {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false
      }
    },

    // per click tabs
    tabClicked(args) {
      switch (args) {
        case 'dialogA1Tab01':
          console.log('Sei nel primo tab del dialogA1')
          break
        case 'dialogA1Tab02':
          console.log('Sei nel secondo tab del dialogA1')
          break
        default:
          console.log(args)
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },

  },
  computed: {
    hasChanged() {
      // console.log(this.calendarioMinisteroActiveData)
      // console.log(this.calendarioMinisteroSavedData)
      return Object.keys(this.calendarioMinisteroActiveData).some(field => this.calendarioMinisteroActiveData[field] !== this.calendarioMinisteroSavedData[field])
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}

// per dropdownlist template
.city {
  right: 15px;
  position: absolute;
}

// per colorare placeholder dropdownlist
// .e-ddl.e-input-group input.e-input::placeholder {
//     color: rgb(199, 113, 113);
// }
</style>
